import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/reports'

Styxie.Initializers.ReportConfigurations = {
  index: async(props) => {
    const { default: Component } = await import('@/vue_widgets/report_configurations/index.vue')
    createVueApp(Component, { props, sidebar })
  },
  new: async(props) => {
    const { default: Component } = await import('@/vue_widgets/report_configurations/form/index.vue')
    createVueApp(Component, { props, sidebar })
  },
  edit: async(props) => {
    const { default: Component } = await import('@/vue_widgets/report_configurations/form/index.vue')
    createVueApp(Component, { props, sidebar })
  }
}
